/** Shared desktop-grid layout constants (single source of truth). */
export const CELL = 96;
export const GAP = 8;
